<template>
    <div>
        <el-dialog :visible.sync="isShow" title="办理入住" width="500px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false" @close="$emit('close')">
            
            <el-form ref="checkForm" :model="checkForm" label-width="100px" style="margin: 0 20px" size="small" :rules="rulesForm">
                <el-form-item label="订单号" prop="orderNo">
                    <el-input type="text" v-model="checkForm.orderNo" disabled style="width: 250px;margin-right: 10px;"></el-input>
                    <el-button type="text" size="small" @click="handleSelectOrder">选择订单</el-button>
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-input type="text" v-model="checkForm.name" placeholder="请输入姓名" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="电话号码" prop="mobile">
                    <el-input type="text" v-model="checkForm.mobile" placeholder="请输入电话号码" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="idNumber">
                    <el-input type="text" v-model="checkForm.idNumber" placeholder="请输入身份证号码" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="退房日期" prop="estimatedCheckOut">
                    <el-date-picker v-model="checkForm.estimatedCheckOut" :disabled="!!checkForm.orderNo" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 250px"></el-date-picker>
                </el-form-item>
                <el-form-item label="金额" prop="collection">
                    <el-input type="text" v-model="checkForm.collection" :disabled="!!checkForm.orderNo" placeholder="请输入金额" style="width: 250px"></el-input>
                </el-form-item>
            </el-form>
    
            <div slot="footer" class="dialog-footer">
                <el-button type="text" size="small" @click="isShow = false">取消</el-button>
                <el-button type="primary" size="small" @click="handleSubmit('checkForm')">办理入住</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="isOrder" title="选择订单" width="750px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false" @close="isOrder = false">
            <el-table border size="small" style="width:100%;margin-top:10px;" :data="orderList" v-loading="isLoading" row-key="orderNo"
                element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-table-column label="#" align="center" width="60">
                    <template slot-scope="{ row }">
                        <el-radio v-model="orderId" :label="row.orderNo" class="select-radio"></el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNo" label="订单号" ></el-table-column>
                <el-table-column prop="roomTypeName" label="房型名称" width="120"></el-table-column>
                <el-table-column prop="name" label="住客姓名" width="120"></el-table-column>
                <el-table-column prop="mobile" label="联系手机" width="100"></el-table-column>
                <el-table-column prop="days" label="预定天数" width="90"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage" style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                
    
            <div slot="footer" class="dialog-footer">
                <el-button type="text" size="small" @click="isOrder = false">取消</el-button>
                <el-button type="primary" size="small" @click="handleConfirm">办理入住</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    props: {
        isCheck: {
            type: Boolean,
            default: false,
        },
        hotelId: {
            type: String,
            default: null,
        },
        roomId: {
            type: String,
            default: null,
        },
    },
    data() {
        const validatePhone = (rule, value, callback) => {
            let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (!reg.test(value)) {
                callback(new Error("手机号格式错误"));
            } else {
                callback();
            }
        }
        const validatePrice = (rule, value, callback) => {
            if (
                (value < 0.01 && value) ||
                !value ||
                !/^\d+(\.\d{1,2})?$/.test(value)
            ) {
                callback(new Error("金额不能小于0.01元且最多只能保留两位小数"));
            } else {
                callback();
            }
        };
        var validateCard = (rule, value, callback) => {
            if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
                callback(new Error('身份证号格式错误且不能为空'));
            } else {

                callback();
            }
        };
        return {
            
            isShow: false,
            checkForm: {
                orderNo: "",
                name: "",
                idNumber: "",
                mobile: "",
                collection: '',
                estimatedCheckOut: ""
            },
            rulesForm: {
                name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                idNumber: [{ required: true, validator: validateCard, trigger: 'blur' }],
                mobile: [{ required: true, validator: validatePhone, trigger: "blur" }],
                collection: [{ required: true, validator: validatePrice, trigger: "blur" }],
                estimatedCheckOut: [{ required: true, message: "请选择退房日期", trigger: "blur" }],
            },
            isOrder: false,
            orderId: "",
            orderList: [],
            total: 0,
            isLoading: false,
            searchForm: {
                pageNumber: 1,
                pageSize: 10
            }
        }
    },
    watch: {
        isCheck(newVal) {
            this.isShow = !!newVal;
            if (!!newVal) {
                this.checkForm = {
                    roomId: this.roomId,
                    orderNo: "",
                    name: "",
                    idNumber: "",
                    mobile: "",
                    collection: '',
                    estimatedCheckOut: ""
                }
            }
        },
    },
    methods: {
        
        handleSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    this.checkForm.clientList = [{
                        idNumber: this.checkForm.idNumber,
                        name: this.checkForm.name,
                        mobile: this.checkForm.mobile
                    }]

                    this.postRequest("/api/room/checkIn", this.checkForm)
                        .then((res) => {
                            this.submitLoading = false;
                            let data = res.data;
                            if (data.code == 200) {
                                this.$message.success(data.msg);
                                this.$emit('confirm')
                            }
                        })
                        .catch(() => {
                            this.submitLoading = false;
                        });
                }
            });
        },
        handleConfirm() {
            if(!this.orderId) {
                this.$message.warning("请选择订单");
                return;
            }
            
            let orderInfo = this.orderList.filter(item => item.orderNo == this.orderId)[0];
            this.checkForm.orderNo = orderInfo.orderNo;
            this.checkForm.name = orderInfo.name;
            this.checkForm.idNumber = orderInfo.idNumber;
            this.checkForm.mobile = orderInfo.mobile;
            this.checkForm.estimatedCheckOut = orderInfo.estimatedCheckOut;
            this.checkForm.collection = orderInfo.lastPay;
            this.isOrder = false;
        },
        handleSelectOrder() {
            this.searchForm = {
                hotelId: this.hotelId,
                status: 1,
                pageNumber: 1,
                pageSize: 10
            };
            this.orderId = "";
            this.getOrderList();
            this.isOrder = true;
        },
        
        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getOrderList();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getOrderList();
        },
        getOrderList() {
            this.isLoading = true;
            this.getRequest("/api/roomOrder/page", this.searchForm)
            .then(res => {
                this.isLoading = false;
                let data = res.data;
                if(data.code == 200) {
                    this.orderList = data.data.records.map(item => {
                        if(item.roomOrderGuestInfoVoList) {
                            item.name = item.roomOrderGuestInfoVoList[0].name;
                            item.mobile = item.roomOrderGuestInfoVoList[0].mobile;
                            item.idNumber = item.roomOrderGuestInfoVoList[0].idNumber;
                        }
                        return item;
                    });
                    this.total = data.data.total;
                }
            })
        }
    },
}
</script>